"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        display: 'flex',
        flexShrink: 0,
        padding: 14,
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit',
        backgroundColor: theme.grey8,
        '& > * + *': {
            marginLeft: 14
        },
        '&[data-has-borderbottom=true]': {
            borderBottom: `1px solid ${theme.grey6}`
        }
    },
    title: {
        flexGrow: 1,
        fontSize: 16,
        fontWeight: 600,
        color: theme.grey1,
        lineHeight: '20px',
        '& strong': {
            color: theme.indigo3
        }
    },
    closeButton: {
        flexShrink: 0
    }
});
//# sourceMappingURL=modal.header.style.js.map